import type { NexusUser } from 'src/app/models/nexus-user';
import type { GraphqlFunctionalGroup } from 'src/app/graphql/models/output/functional-group.output.model';
import type { GraphqlNexusUser } from 'src/app/graphql/models/output/nexus-user.output.model';
import { FunctionalGroup } from 'src/app/models/functional-group';
import { NexusUserFunctionalGroup } from 'src/app/models/nexus-user-functional-group';
import { GraphqlNexusUserFunctionalGroup } from 'src/app/graphql/models/output/nexus-user-functional-group.output.model';

/**
 * Converts graphql nexus user to internal object.
 * @param input Graphql object.
 * @returns Internal representation of source object.
 */
export function convertGraphqlNexusUserToNexusUser(input: GraphqlNexusUser): NexusUser {
	return {
		username: input.username,
		subjectUid: input.subjectUid,
		name: input.name,
		functionalGroups: input.functionalGroups.map(group => convertGraphqlNexusUserFunctionalGroupToNexusUserFunctionalGroup(group)),
		groupUids: input.groupUids,
		isAdministrator: input.isAdministrator,
		isSuperUser: input.isSuperUser,
		email: input.email,
	};
}

/**
 * Converts graphql functional group to internal object.
 * @param input Graphql object.
 * @returns Internal representation of source object.
 */
export function convertGraphqlFunctionalGroupToFunctionalGroup(input: GraphqlFunctionalGroup): FunctionalGroup {
	return {
		description: input.description,
		name: input.name,
		uid: input.uid,
	};
}

/**
 * Converts graphql nexus user functional group to internal object.
 * @param input Graphql object.
 * @returns Internal representation of source object.
 */
function convertGraphqlNexusUserFunctionalGroupToNexusUserFunctionalGroup(input: GraphqlNexusUserFunctionalGroup): NexusUserFunctionalGroup {
	return {
		functionalGroupUid: input.functionalGroupUid,
		functionalGroupName: input.functionalGroupName,
		isDefault: input.isDefault,
	};
}
